/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RowData } from './rowData';

/**
 * Fiat deposit instruction update request
 */
export interface FiatDepositInstructionUpdateRequest {
  name: string;
  nameForClient: string;
  assetId: number;
  data: Array<RowData>;
  id: number;
}
